import { useState, useEffect } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate, useLocation } from "react-router-dom";
import { FaArrowRight, FaBuilding, FaUserEdit, FaTag, FaCalendarAlt, FaInfoCircle } from "react-icons/fa";

export default function CreateMissionPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const { backEnd_request } = BackMethods();

    // حالات الحقول الأساسية
    const [fieldUID, setFieldUID] = useState("");
    const [assignedToUserId, setAssignedToUserId] = useState("");
    const [missionType, setMissionType] = useState("");
    const [instructions, setInstructions] = useState("");
    const [dueDateUtc, setDueDateUtc] = useState("");

    // حالات البحث والبيانات
    const [searchTerm, setSearchTerm] = useState("");
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [complaintUid, setComplaintUid] = useState("");
    useEffect(() => {
        if (location.state?.fieldUID) {
            setFieldUID(location.state.fieldUID);
            setSearchTerm(location.state.establishmentName);
        }
        if (location.state?.complaintUid) {
            setComplaintUid(location.state.complaintUid);
            console.log(location.state.complaintUid);
        }
        fetchUsers();
    }, [location.state]);

    const fetchUsers = async () => {
        try {
            const res = await backEnd_request.get("/admin/UsersManagement", {
                params: {
                    PageSize: 100,
                    Page: 1
                }
            });
            setUsers(res.data.users || []);
        } catch (error) { console.error("Error fetching users", error); }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessage("");
        console.log(complaintUid);
        const payload = {
            fieldUID: fieldUID,
            assignedToUserId: Number(assignedToUserId),
            missionType: missionType.trim(),
            instructions: instructions.trim(),
            dueDateUtc: new Date(dueDateUtc).toISOString(),
            complaintUid: complaintUid
        };
        console.log(payload);
        try {
            await backEnd_request.post("/InspectionMissions", payload);
            setSuccessMessage("تم إسناد المهمة بنجاح ✅");
            setTimeout(() => navigate(-1), 1500);
        } catch (err) {
            setErrorMessage(err.response?.data?.message || "حدث خطأ أثناء حفظ البيانات");
            setLoading(false);
        }
    };

    return (
        <div className="container-fluid py-5" style={{ minHeight: "100vh", backgroundColor: "#f8f9fa", direction: "rtl", fontFamily: "'Cairo', sans-serif" }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8">

                        {/* Header Section */}
                        <div className="d-flex align-items-center justify-content-between mb-4">
                            <div>
                                <h2 className="fw-bold text-dark mb-1">إسناد مهمة جديدة</h2>
                                <p className="text-muted small">تعبئة تفاصيل التكليف الرسمي للمفتش</p>
                            </div>
                            <button onClick={() => navigate(-1)} className="btn btn-white shadow-sm border-0 px-3 py-2 rounded-3 text-secondary">
                                <FaArrowRight className="ms-2" /> رجوع
                            </button>
                        </div>

                        <div className="card border-0 shadow-sm overflow-hidden" style={{ borderRadius: "24px" }}>
                            {/* Banner للمنشأة المختارة */}
                            <div className="bg-primary p-4 text-white d-flex align-items-center">
                                <div className="bg-white bg-opacity-25 rounded-circle p-3 ms-3">
                                    <FaBuilding size={24} />
                                </div>
                                <div>
                                    <span className=" fw-bold text-light">المهمة مخصصة لـ:</span>
                                    <h4 className="mb-0 fw-bold">{searchTerm || "منشأة غير محددة"}</h4>
                                </div>
                            </div>

                            <div className="card-body p-4 p-md-5">
                                {successMessage && (
                                    <div className="alert alert-success border-0 rounded-4 py-3 mb-4 animate__animated animate__fadeIn">
                                        {successMessage}
                                    </div>
                                )}
                                {errorMessage && (
                                    <div className="alert alert-danger border-0 rounded-4 py-3 mb-4">
                                        {errorMessage}
                                    </div>
                                )}

                                <form onSubmit={handleSubmit}>
                                    <div className="row g-4">

                                        {/* المفتش المسؤول */}
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold text-secondary small"><FaUserEdit className="ms-1" /> المفتش المسؤول</label>
                                            <select
                                                className="form-select border-0 bg-light py-3 px-4"
                                                style={{ borderRadius: "15px" }}
                                                value={assignedToUserId}
                                                onChange={(e) => setAssignedToUserId(e.target.value)}
                                                required
                                            >
                                                <option value="">اختر المفتش...</option>
                                                {users.map((u) => (
                                                    <option key={u.userId} value={u.userId}>{u.firstName} {u.lastName} ({u.username})</option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* تصنيف المهمة */}
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold text-secondary small"><FaTag className="ms-1" /> تصنيف المهمة</label>
                                            <input
                                                type="text"
                                                className="form-control border-0 bg-light py-3 px-4"
                                                style={{ borderRadius: "15px" }}
                                                placeholder="مثال: جولة تفتيشية"
                                                value={missionType}
                                                onChange={(e) => setMissionType(e.target.value)}
                                                required
                                            />
                                        </div>

                                        {/* موعد الإنجاز */}
                                        <div className="col-md-12">
                                            <label className="form-label fw-bold text-secondary small"><FaCalendarAlt className="ms-1" /> موعد الإنجاز النهائي</label>
                                            <input
                                                type="datetime-local"
                                                className="form-control border-0 bg-light py-3 px-4"
                                                style={{ borderRadius: "15px" }}
                                                value={dueDateUtc}
                                                onChange={(e) => setDueDateUtc(e.target.value)}
                                                required
                                            />
                                        </div>

                                        {/* التعليمات */}
                                        <div className="col-12">
                                            <label className="form-label fw-bold text-secondary small"><FaInfoCircle className="ms-1" /> تعليمات المهمة</label>
                                            <textarea
                                                className="form-control border-0 bg-light py-3 px-4"
                                                style={{ borderRadius: "15px" }}
                                                rows={4}
                                                placeholder="اكتب هنا تفاصيل المهمة والتعليمات الموجهة للمفتش..."
                                                value={instructions}
                                                onChange={(e) => setInstructions(e.target.value)}
                                                required
                                            />
                                        </div>

                                        {/* أزرار التحكم */}
                                        <div className="col-12 d-flex gap-3 mt-4">
                                            <button
                                                type="submit"
                                                className="btn btn-primary w-100 py-3 fw-bold shadow-sm"
                                                style={{ borderRadius: "15px" }}
                                                disabled={loading}
                                            >
                                                {loading ? (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                ) : "تأكيد وإرسال المهمة"}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-light text-secondary px-4 py-3 fw-bold"
                                                style={{ borderRadius: "15px" }}
                                                onClick={() => navigate(-1)}
                                            >
                                                إلغاء
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style>{`
                .form-control:focus, .form-select:focus {
                    background-color: #fff !important;
                    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.1) !important;
                    border: 1px solid #0d6efd !important;
                }
                .btn-white:hover {
                    background-color: #f1f3f5;
                }
            `}</style>
        </div>
    );
}